<template>
    <div class="searcher-ai-wrapper">
        <el-row :gutter="10" class="input-wrapper-row">
            <el-col class="input-wrapper">
                <div class="input-group">
                    <textarea v-model="question" id="question-input" class="question-input" placeholder="Ich suche..."
                        v-on:keyup.enter="startSearch" maxlength="2000"></textarea>


                    <button class="search-btn" @click="startSearch" :disabled="question.trim() === ''"
                        :class="{ 'active': question.trim() !== '' }">
                        <img src="/media/images/web_search/ai_icon.svg" alt="AI Icon" class="ai-icon" />
                    </button>
                </div>
                <el-popover class="popover-wrapper" placement="top" v-model:visible="infoVisible" trigger="manual"
                    popper-class="info-popover" width="200"
                    :popper-style="{ backgroundColor: 'white', border: '1px solid #41ABC4', width: '400px', height: '400px', boxShadow: '4px 4px 12px #00000043', border: '2px solid #41ABC4', borderRadius: '13px' }"
                    :show-arrow="false">
                    <template #reference>
                        <button class="info-icon" @click.stop="toggleInfo">𝒊</button>
                    </template>
                    <div class="popover-content">
                        <div class="popover-header">
                            <div class="info-icon-large">𝒊</div>
                        </div>
                        <h3 class="popover-title">Suchen und finden</h3>
                        <div class="info-content">
                            <p>
                                In der Matchmaker-Suche können Sie mit unseren Keywords arbeiten und unter über 10.000
                                Kompetenzen auswählen.
                                Oder aber Sie nutzen unseren KI-Assistenten und beschreiben in kurzen Worten Ihr
                                Anliegen.
                            </p>
                        </div>
                        <button class="close-btn" @click="infoVisible = false">✕</button>
                    </div>
                </el-popover>
            </el-col>
        </el-row>

        <div class="icons-wrapper">
            <div class="icon-item">
                <img src="/media/images/web_search/secure-payment.svg" alt="Secure Payment" style="width: 22px;" />
                <p>Sichere Bezahlung</p>
            </div>
            <div class="icon-item">
                <img src="/media/images/web_search/dsgco.svg" alt="DSGCO" />
                <p>DSGVO-konforme Signaturen</p>
            </div>
            <div class="icon-item">
                <img src="/media/images/web_search/projects-insured.svg" alt="Projects Insured" />
                <p>Versicherte Projekte</p>
            </div>
            <div class="icon-item">
                <img src="/media/images/web_search/documents-checked.svg" alt="Documents Checked" />
                <p>Alle Dokumente geprüft</p>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    props: {
        mainFilters: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            question: "",
            infoVisible: false,
        };
    },
    methods: {
        autoResizeTextArea(event) {
            const textarea = event.target;
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;

            if (textarea.scrollHeight > 100) {
                textarea.classList.add('resizable');
            } else {
                textarea.classList.remove('resizable');
            }
        },
        async startSearch() {
            if (this.mainFilters.length >= 10) {
                this.$emit('maxCompetencesLimitReached');
                return;
            }

            if (this.question.trim() === "") return;
            this.$functions.showLoader();
            try {
                await api.apiClient.get('/sanctum/csrf-cookie');
                const response = await api.apiClient.post('api/ai/response', {
                    thread_id: null,
                    run_id: null,
                    question: this.question,
                }, { withCredentials: true });

                const skillIds = response.data.skill_ids || [];
                const remainingSlots = 10 - this.mainFilters.length;
                const newSkills = skillIds.filter(id => !this.mainFilters.includes(id)).slice(0, remainingSlots);
                this.$emit('searchResults', newSkills);
            } catch (error) {
                console.error("Error:", error);
                this.$functions.hideLoader();
            }
        },
        toggleInfo() {
            this.infoVisible = !this.infoVisible;
        },
        closeInfoOnOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.infoVisible = false;
            }
        }
    },
    mounted() {
        document.addEventListener("click", this.closeInfoOnOutsideClick);
        const textarea = this.$el.querySelector('.question-input');
        textarea.addEventListener('input', this.autoResizeTextArea);
        const urlParams = new URLSearchParams(window.location.search);
        const query = urlParams.get('query');

        if (query) {
            this.question = query;
            setTimeout(() => {
                this.startSearch();
            }, 500);
        }
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeInfoOnOutsideClick);
        const textarea = this.$el.querySelector('.question-input');
        textarea.removeEventListener('input', this.autoResizeTextArea);
    }
};
</script>


<style scoped>
.icons-wrapper {
    display: flex;
    justify-content: center;
}

.icon-item {
    display: contents;
    flex-direction: column;
    align-items: center;
}

.icon-item img {
    width: 25px;
    height: 30px;
    padding-right: 7px;
}

.icon-item p {
    margin-top: 5px;
    font-size: 12px;
    color: #8e8d8c;
    margin-right: 35px;
}

.ai-icon {
    width: 32px;
    height: 30px;
}

.input-wrapper-row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    padding: 20px;
    padding-top: 10px;
}

.input-wrapper {
    flex: unset;
    justify-content: center;
    align-items: center;
    display: flex !important;
}

.input-group {
    border: 1px solid #c7c7c7;
    background-color: #fff;
    border-radius: 11px;
    width: 800px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
}

.question-input {
    border: none;
    background-color: transparent;
    flex-grow: 1;
    font: normal normal normal 1rem/1rem Inter;
    padding: 5px;
    color: #696969;
}

.question-input:focus {
    outline: none;
}

.resizable {
    resize: vertical;
}

.search-btn {
    padding: 5px !important;
    background-color: transparent;
    border: none;
    cursor: default;
    border: 1px solid #7a8dcc;
}

.search-btn.active {
    cursor: pointer;
    background: linear-gradient(90deg, #a06dd6, #9e6ed6, #8f7ad1, #8682cf, #8385ce, #7e89cd, #7a8dcc, #7690ca, #7294c9, #6d9ac7, #6d9ac7, #699fc6, #68a0c6, #67a2c5);
}

.search-btn.active img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);
}

.arrow-image {
    width: 35px;
    height: 35px;
    transform: rotate(270deg);
    filter: invert(80%) sepia(0%) saturate(43%) hue-rotate(141deg) brightness(98%) contrast(101%);
}

.search-btn.active .arrow-image {
    filter: invert(70%) sepia(81%) saturate(549%) hue-rotate(158deg) brightness(81%) contrast(88%);
}

.info-icon {
    width: 22px;
    height: 22px;
    background-color: #B1B1B1;
    border: none;
    border-radius: 50%;
    font-size: 19px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
    line-height: 22px;
    margin-left: 16px;
    padding: unset;
    font-family: "KaTeX Math", serif;
    color: #fff;
}

.info-icon:hover {
    background-color: #bbb;
}

:deep(.info-popover) {
    height: 300px !important;
}

.el-popover :deep(.el-popper__arrow) {
    display: none !important;
}

:deep(.el-popover__title) {
    text-align: center;
}

.info-content {
    position: relative;
}

.info-content p {
    letter-spacing: -0.36px;
    color: #3C3C3C;
    font: normal normal normal 18px/32px Inter;
    margin-top: -17px;
}

.info-icon:hover {
    background-color: #bbb;
}

.popover-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
}

.info-icon-large {
    width: 35px;
    height: 35px;
    background-color: #41ABC4;
    color: white;
    border-radius: 50%;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 35px;
    font-family: "KaTeX Math", serif;
}

.popover-title {
    text-align: center;
    font: italic normal 500 32px/50px Cormorant Garamond;
    letter-spacing: -0.96px;
    color: #4D5255;
    opacity: 1;
}

.info-content {
    font-size: 14px;
    color: #333;
    text-align: center;
}

.close-btn {
    position: absolute;
    top: -10px;
    right: -20px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    color: #707070;
}

textarea {
    resize: none;
    height: 15px;
    overflow-y: hidden;
}

@media (max-width: 768px) {
    .icons-wrapper {
        display: none;
    }

    .info-icon {
        display: none;
    }

    .search-btn {
        border: 2px solid #7a8dcc;
    }

    .input-wrapper-row {
        padding: unset;
        padding-top: 20px;
        padding-top: 0px;
        padding-bottom: 10px;
        width: unset;
    }
}
</style>
